<div class="w-full mt-8 display flex flex-col gap-6">
  <!-- <div class="flex flex-col gap-3">
    <h1 class="text-[30px] font-bold">Catalogo de sistemas de IA</h1>
    <span class="text-[16px]">
      Este catálogo permite recopilar, describir y supervisar los sistemas de IA que se utilizan en el Gobierno de
      Aragón. Aquí se describen los proyectos, qué algoritmo de IA se utiliza en cada uno de ellos y cómo se implementa.
    </span>
  </div>
  <app-tabs
    class="mt-4"
    [type]="'tabsWithURL'"
    [items]="tabsOpcion()" /> -->

  <div class="flex w-full justify-between items-center">
    <div class="py-2 w-full font-bold text-[24px] leading-snug">Proyectos de IA</div>
    <div
      class="flex flex-col items-end gap-2"
      [attr.title]="!canCreateProject ? noCreateProjectPermissionMessage : null">
      <app-buttons
        [classes]="'bg-primary-base text-white'"
        [label]="'Dar de alta un proyecto'"
        [disabled]="!canCreateProject"
        [routerLink]="'/catalogo-ia/proyectos/nuevo-proyecto'" />
    </div>
  </div>
  <div class="text-[16px]">
    Cada proyecto o solución tecnológica que utiliza IA en el Gobierno de Aragón se registra en este catálogo, que
    incorpora una descripción del algoritmo utilizado, sus aspectos funcionales, económicos, de impacto interno y
    externo, la gestión de riesgos y la sostenibilidad, así como los relativos al cumplimiento normativo del Reglamento
    de Inteligencia Artificial y de Protección de Datos.
  </div>
  <app-tabs
    class="mt-4"
    type="tabsWithButtons"
    defaultTab="myProjects"
    [items]="tabOptions()"
    (tabChanged)="onTabChange($event)" />
  <app-search-bar
    [showExternalButton]="true"
    [placeholder]="'Buscar por nombre, código u organismo'"
    (search)="handleSearch($event)" />

  <app-filters
    [filtersAdvanced]="visibleAdvancedFilters()"
    [title]="'Buscar por filtros'"
    (applyFilters)="handleApplyFilters($event)"
    [containerClass]="'flex flex-wrap gap-x-8 gap-y-6 items-end justify-start max-w-[70%]'" />

  <div class="flex min-w-[1200px] justify-between items-end">
    <span class="text-md font-bold">{{ total() }} proyectos</span>
    <app-dropdown
      [options]="orderby.options ?? []"
      [hiddenArrow]="true"
      [label]="orderby.label ?? ''"
      [icon]="orderby.icon ?? ''"
      [classes]="orderby.classes ?? ''"
      (select)="onDropdownChange($event)" />
  </div>

  <span
    class="text-[16px] font-regular text-neutral-base"
    *ngIf="total() === 0">
    No se encontraron proyectos
  </span>
  <div *ngFor="let card of cards()">
    <app-project-card
      [projectName]="card?.projectName ?? ''"
      [state]="card?.state ?? ''"
      [buttons]="$any(card?.buttons ?? [])"
      [creationUser]="card?.creationUser ?? ''"
      [creationDate]="card?.date ?? defaultCardDate"
      [infoCard]="$any(card?.infoCard ?? [])"
      [description]="card?.description ?? ''"></app-project-card>
  </div>

  <app-pagination
    [totalItems]="total()"
    [paginationSize]="paginationSize()"
    [currentPage]="currentPage()"
    (paginationSizeChange)="paginationSize.set($event)"
    (currentPageChange)="currentPage.set($event)" />
</div>
